<template>
  <div>
    <div class="container-fluid footer">
      <div class="row">
        <div
          v-for="(widget, index) in primary"
          :key="index"
          class="footer-primary"
          :class="getClass(primary, false, index)"
        >
          <h4 class="footer-title" v-html="widget.data.title.replace('|', '<br>')"></h4>
          <span
            class="footer-content"
            v-if="widget.widget == 'text'"
            v-html="widget.data.text.replace(/\r\n/g, '<br/>')"
          ></span>
          <span
            class="footer-content"
            v-if="widget.widget == 'custom_html'"
            v-html="widget.data.content.replace(/\r\n/g, '<br/>')"
          ></span>
        </div>
      </div>
      <div class="row">
        <div
          v-for="(widget, index) in secondary"
          :key="index"
          class="col col-lg-8 offset-lg-2 footer-secondary"
        >
          <h4 class="footer-title" v-html="widget.data.title.replace('|', '<br>')"></h4>
          <span
            class="footer-content"
            v-if="widget.widget == 'text'"
            v-html="widget.data.text.replace('\r\n', '<br>')"
          ></span>
          <span
            class="footer-content"
            v-if="widget.widget == 'custom_html'"
            v-html="widget.data.content.replace('\r\n', '<br>')"
          ></span>
        </div>
      </div>
      <div class="row">
        <div class="col footer-copyright">
          <span class="copyright">© {{name}} {{ new Date().getFullYear() }}</span>
        </div>
      </div>
      <div v-if="pp_url" class="private-policy">
        <div class="row">
          <a class="col-12 col-md-6" :href="pp_url">
            <span>{{pp_translations.title}}</span>
          </a>
          <button
            type="button"
            class="col-12 col-md-6"
            @click="eventTwoEmitter('emitChangeBoolean', 'policyReaded', 'emitChangeTrue', 'cookiePageSwitch')"
          >
            <span>{{pp_translations.cookie_settings}}</span>
          </button>
        </div>
      </div>
    </div>
    <div v-if="above" class="container-fluid above">
      <div class="row">
        <div
          v-for="(widget, index) in above"
          :key="index"
          class="footer-primary col-12"
          :class="getClass(above, true, index)"
        >
          <h4 class="footer-title" v-html="widget.data.title.replace('|', '<br>')"></h4>
          <span
            class="footer-content"
            v-if="widget.widget == 'text'"
            v-html="widget.data.text.replace('\r\n', '<br>')"
          ></span>
          <span
            class="footer-content"
            v-if="widget.widget == 'custom_html'"
            v-html="widget.data.content.replace('\r\n', '<br>')"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">

.above {
  color: rgb($quinary-color);
  background: rgb($quaternary-color);
  padding: 15px 13vw;
  text-align: justify;
  line-height: 1.2;
  font-weight: 200;
  font-size: 90%;
  text-align: center;

  img {
    max-width: 100%;
  }
  p {
    margin: 20px 0;
    text-align: justify;
  }
}

@media (max-width: 992px) { 
  .above {
    font-size: 70%;
  }
 }

 @media (max-width: 576px) { 
  .above {
    font-size: 50%;
  }
 }

.footer {
  padding: 50px 13vw;
  background: rgb($senary-color);
  color: rgb($quaternary-color);
  text-align: center;
  line-height: 1.2;
  a,
  button {
    color: rgb($quaternary-color);
    font-weight: 300;
  }
  a:hover,
  button:hover {
    color: rgb($quaternary-color);
    text-decoration: underline rgb($secondary-color);
  }

  .row {
    padding-top: 20px;
  }

  span {
    display: block;
  }

  .footer-title {
    font-weight: 500;
  }

  .footer-content {
    font-weight: 300;
  }

  .footer-primary {
    font-size: 1.4rem;
    margin-bottom: 20px;
  }

  .footer-secondary {
    font-size: 14pt;
    margin-bottom: 20px;
  }

  .footer-copyright {
    font-size: 14pt;
    font-weight: 300;
  }
  .private-policy {
    font-size: 14pt;
    margin: 0 20vw;
    div {
      margin-left: auto;
      margin-right: auto;
    }
    a, button {
      padding: 5px 0;
      }
    span {
      color: rgba($quaternary-color, 0.7);
    }
  }
}
</style>

<script>
// import fcwpSidebarContent from "./content/fcwpSidebarContent.vue";

export default {
  name: "fcwpFooter",
  props: [
    "name",
    "above",
    "primary",
    "secondary",
    "pp_url",
    "pp_title",
    "pp_translations"
  ],
  methods: {
    getClass(array, unequal, index) {
      if (unequal == false) {
        if (array.length == 1) {
          return '';
        } else if (array.length == 3) {
          return 'col-md-4';
        } else {
          return 'col-md-6';
        }
      } else {
        if (index == 0) {
          return 'col-md-6';
        } else {
          return 'col-md-3';
        }
      }

    },
    eventTwoEmitter(method, value, methodTwo, valueTwo) {
      this.$root.$emit(methodTwo, valueTwo);
      this.$root.$emit(method, value);
    }
  }
};
</script>